var path = 'src/app/patients/current-medications/medications.html';
var html = "<h1 class=page-header>Current Medications</h1> <div current-medications-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/current-medications/medications.html
 ** module id = 411
 ** module chunks = 0
 **/